import React from "react";

import TourModalContainer from "custom-components/shared/Tour/TourModal/TourModalContainer";
import Topbar from "components/Topbar/Topbar";

class AhmaTopBar extends Topbar {
  renderTourModal() {
    return (
      <TourModalContainer
        projectId={this.props.projectId}
        showModal={this.props.showTourModal}
        handleCloseModal={this.props.handleCloseTourModal}
        language={this.props.language}
      />
    );
  }
}

export default AhmaTopBar;
